export default "__VITE_ASSET__2c3cd69e__"